import React from "react";

const LORA = { fontFamily: "'Lora', Georgia, serif" };

const JOURS_FR = ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"];

function chipLabel(jour) {
  try {
    const d = new Date(jour.date + "T00:00:00");
    return `J${jour.numero_jour} · ${JOURS_FR[d.getDay()]} ${d.getDate()}`;
  } catch {
    return `J${jour.numero_jour}`;
  }
}

export function DaySelector({ jours, activeIndex, onSelectDay }) {
  return (
    <div
      className="sticky bg-[#F9F6F0] border-b border-[#DCD4C6] py-2.5 z-20 -mx-5 px-5 sm:-mx-8 sm:px-8"
      style={{ top: "62px" }}
      data-testid="day-selector"
    >
      <div
        className="flex gap-2 overflow-x-auto pb-0.5"
        style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
      >
        {jours.map((jour, idx) => (
          <button
            key={jour.numero_jour}
            onClick={() => onSelectDay(idx)}
            className={`flex-shrink-0 px-3 py-1.5 text-xs rounded-sm border transition-all ${
              activeIndex === idx
                ? "bg-[#C17F59] text-[#F9F6F0] border-[#C17F59]"
                : "bg-[#F9F6F0] text-[#5C554E] border-[#DCD4C6] hover:border-[#C17F59] hover:text-[#C17F59]"
            }`}
            style={LORA}
            data-testid={`day-chip-${idx + 1}`}
          >
            {chipLabel(jour)}
          </button>
        ))}
      </div>
    </div>
  );
}
